import React from 'react';
import classnames from 'classnames';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import SlideContent from './SlideContent';
import ConvertAttributeIcon from 'components/Icons/ConvertAttribute';
import CreateNewAttributeIcon from 'components/Icons/CreateNewAttribute';

interface Props {
  classes: any;
  setSlideIndex: (slideIndex: number) => void;
  onSetOpen: (status: boolean) => void;
}

function AttributeSlide({ classes, setSlideIndex, onSetOpen }: Props) {
  return (
    <SlideContent
      slideTitle="How would you like to create attribute pages?"
      slideSubtitle="A page type of attribute pages is also an attribute on profiles"
      renderBackIcon={true}
      renderCloseIcon={true}
      setSlideIndex={setSlideIndex}
      onSetOpen={onSetOpen}
    >
      <div className={classes.row}>
        <Card
          data-testid="existing card"
          classes={{ root: classes.paper }}
          className={classnames(classes.card, classes.marginRight3)}
          onClick={() => setSlideIndex(3)}
        >
          <CardContent className={classes.cardContent}>
            <ConvertAttributeIcon className={classes.cardImage} />
            <Typography
              className={classnames(classes.marginBottom2, classes.textAlignCenter)}
              variant="h6"
            >
              Convert an existing attribute
            </Typography>
            <Typography variant="body2">
              Choose an existing Short Text or Text (Chip) Collection attribute to attach pages to.
              If the attribute already has existing values, we will automatically create pages for
              each value. If this attribute is mapped from a data source, pages will be
              automatically created and deleted during data sync.
            </Typography>
          </CardContent>
        </Card>
        <Card
          data-testid="new card"
          classes={{ root: classes.paper }}
          className={classes.card}
          onClick={() => setSlideIndex(4)}
        >
          <CardContent className={classes.cardContent}>
            <CreateNewAttributeIcon className={classes.cardImage} />
            <Typography className={classes.marginBottom2} variant="h6">
              Create a new attribute
            </Typography>
            <Typography variant="body2">
              If you do not have an existing attribute to attach to, you may create one.
            </Typography>
          </CardContent>
        </Card>
      </div>
    </SlideContent>
  );
}

export default AttributeSlide;
